import React, { useState, useRef } from "react";
import Formsy from "formsy-react";
import { inject, observer } from "mobx-react";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import PasswordInput from "../../components/forms/inputs/PasswordInput";
import SubmitButtonInput from "../../components/forms/inputs/SubmitButtonInput";

const useStyles = makeStyles(theme =>
  createStyles({
    formContainer: {},
    formItem: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  })
);

function ChangePasswordForm(
  { notificationStore, user },
  { _validationErrors }
) {
  const [validForm, setValidForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const form = useRef(null);

  const onResult = _updateInputsWithError => (success, json) => {
    setLoading(false);
    if (success) {
      notificationStore.success("Password successfully changed!");
      form.current.reset();
      return;
    } else {
      if (json) {
        form.current.updateInputsWithError(json);
      }
      notificationStore.error("Password was not changed!");
      return;
    }
  };

  const classes = useStyles();

  return (
    <Formsy
      ref={form}
      onValidSubmit={(model, resetForm, invalidateForm) => {
        setLoading(true);
        user &&
          user
            .changePassword(model)
            .then(([success, response]) =>
              onResult(invalidateForm, form)(success, response)
            );
      }}
      onValid={() => setValidForm(true)}
      onInvalid={() => setValidForm(false)}
    >
      <Grid
        className={classes.formContainer}
        container
        alignContent="flex-start"
        alignItems="center"
      >
        <Grid className={classes.formItem} item sm={12} lg={3}>
          <PasswordInput name="old_password" label="Old Password" required />
        </Grid>
        <Grid className={classes.formItem} item sm={12} lg={3}>
          <PasswordInput
            name="new_password"
            label="New Password"
            required
            validations={{
              minLength: "8"
            }}
            validationErrors={{
              minLength: "Passwords must be at least 8 characters."
            }}
          />
        </Grid>
        <Grid className={classes.formItem} item sm={12} lg={3}>
          <PasswordInput
            name="new_password_confirm"
            label="Confirm Password"
            required
            validations={{
              equalsField: "new_password"
            }}
            validationErrors={{
              equalsField: "Passwords must match."
            }}
          />
        </Grid>
        <Grid className={classes.formItem} item sm={12} lg={3}>
          <SubmitButtonInput
            name="submit"
            contents="Change Password"
            validForm={validForm}
            loading={loading}
            elementProps={{
              color: "primary"
            }}
          />
        </Grid>
      </Grid>
    </Formsy>
  );
}

export default inject(stores => ({
  user: stores.rootStore.authStore.user,
  notificationStore: stores.rootStore.notificationStore
}))(observer(ChangePasswordForm));
